/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint no-param-reassign: 0 */
import * as Blockly from 'blockly';
import { ModalField } from './modalField';
import {
  ROWS, COLS, emptyLeds, presetToLeds, PRESETS,
} from './matrixOled128x64Leds';
import './matrixOled128x64Modal.scss';

// Deben coincidir con el tamaño de las miniaturas en el SCSS: el paso de las flechas del cajón
// se calcula con ellos.
const PRESET_WIDTH = 100;
const PRESET_GAP = 10;

// Divergencia deliberada con el legacy (que invertía el slider): mínimo = trazo fino, máximo = grueso.
const BRUSH_MAPPING = [1, 2, 3, 5, 7, 9, 11, 13, 15, 17];
const mapBrushValue = (value) => BRUSH_MAPPING[value - 1];

const BrushTypes = { BRUSH: 'brush', ERASE: 'erase' };

const downsampleRows = (leds, factor) => {
  let rows = '';
  for (let rowStart = 0; rowStart < ROWS; rowStart += factor) {
    let cells = '';
    for (let colStart = 0; colStart < COLS; colStart += factor) {
      let sum = 0;
      for (let i = 0; i < factor; i += 1) {
        for (let j = 0; j < factor; j += 1) {
          sum += leds[((rowStart + i) * COLS) + (colStart + j)] ? 1 : 0;
        }
      }
      const n = sum / (factor * factor);
      let op = '';
      if (n > 0.75) op = 'opacity100';
      else if (n > 0.50) op = 'opacity75';
      else if (n > 0.25) op = 'opacity50';
      else if (n > 0) op = 'opacity25';
      cells += `<div class="led ${sum > 0 ? `led-on ${op}` : ''}"></div>`;
    }
    rows += `<div class="led-row">${cells}</div>`;
  }
  return rows;
};

// El valor del campo es { frames: [{ leds: {0..8191: bool}, duration }] }.
export class MatrixOled128x64Modal extends ModalField {
  name_ = 'MatrixOled128x64';

  blockWidth_ = 175;

  blockHeight_ = 165;

  currentFrame_ = 0;

  maximized_ = false;

  brushWidth_ = mapBrushValue(7);

  brushType_ = BrushTypes.BRUSH;

  // Quirk preservado de prod: al apagar la regla por primera vez rulerBlanked_ queda en true para
  // siempre y las marcas que no caen cada 8 ya no vuelven (ver dataContentAttr).
  rulerOn_ = false;

  rulerBlanked_ = false;

  openDrawer_ = null;

  painting_ = false;

  drawerEvents_ = [];

  // Garantiza que haya frames en el valor: paintAround muta los leds en el lugar.
  showEditor_() {
    if (!this.value_ || !this.value_.frames || !this.value_.frames.length) {
      this.setValue({ frames: [{ leds: emptyLeds(), duration: 1000 }] });
    }
    this.maximized_ = false;
    this.currentFrame_ = 0;
    this.openDrawer_ = null;
    this.rulerOn_ = false;
    this.rulerBlanked_ = false;
    this.brushType_ = BrushTypes.BRUSH;
    this.buildEditor_();
  }

  // Como ModalField.showEditor_, pero en la vista ampliada el click en el backdrop vuelve a la
  // compacta en vez de cerrar.
  buildEditor_() {
    const backDrop = document.createElement('div');
    backDrop.className = `${this.name_}BackDrop`;

    const div = document.createElement('div');
    div.innerHTML = this.renderModalContent_();
    div.className = `${this.name_}Modal${this.maximized_ ? ' maximized' : ''}`;
    div.classList.add('initial-animation');

    Blockly.WidgetDiv.createDom();
    const widgetDiv = Blockly.WidgetDiv.getDiv();
    if (widgetDiv) {
      widgetDiv.style.top = 0;
      backDrop.appendChild(div);
      widgetDiv.appendChild(backDrop);
    }

    this.addModalEvents();

    this.addEvent_(backDrop, 'click', this, (event) => {
      if (event.target !== backDrop) return;
      if (this.maximized_) {
        this.toggleMaximized(false);
      } else {
        this.updateWorkspace();
        this.closeModal();
      }
    });
  }

  // ------------------------------ datos ---------------------------------

  frames() {
    const frames = this.value_ && this.value_.frames;
    return (frames && frames.length) ? frames : [{ leds: emptyLeds(), duration: 1000 }];
  }

  currentLeds() {
    const frame = this.frames()[this.currentFrame_];
    return (frame && frame.leds) ? frame.leds : emptyLeds();
  }

  setFrames(frames) {
    this.setValue({ ...this.value_, frames });
    this.paintBlockContent();
  }

  setFrameDuration(i, duration) {
    this.setFrames(this.frames().map((f, idx) => (idx === i ? { ...f, duration } : f)));
  }

  setCurrentLeds(leds) {
    this.setFrames(this.frames().map(
      (f, idx) => (idx === this.currentFrame_ ? { ...f, leds } : f),
    ));
  }

  // ------------------------------ vista chica (bloque) ---------------------

  renderBlockContent_() {
    const leds = (this.frames()[0] && this.frames()[0].leds) || emptyLeds();
    return `<div class="oled-mini"><div class="mini-leds-container">${downsampleRows(leds, 8)}</div></div>`;
  }

  // ------------------------------ sidebar (comun) --------------------------

  renderPicker(drawer, title) {
    return `<span class="picker picker-${drawer}${this.openDrawer_ === drawer ? ' selected' : ''}" data-drawer="${drawer}" title="${title}"></span>`;
  }

  renderDrawer() {
    if (!this.openDrawer_) return '';
    const items = Object.keys(PRESETS[this.openDrawer_])
      .map((n) => `<span class="preset preset-${this.openDrawer_}-${n}" data-preset="${n}"></span>`)
      .join('');
    return `<div class="drawer-scroller">${items}</div>`;
  }

  renderSidebar(maximized) {
    const ruler = maximized
      ? `<span class="button ruler${this.rulerOn_ ? ' ruler-on' : ''}" title="Numerar filas y columnas"><span class="icon-grid"></span></span>`
      : '';
    const brushSlider = maximized
      ? `
        <div class="icon-brush">
          <span class="brush-icon${this.brushType_ === 'brush' ? ' selected' : ''}" title="Pintar"></span>
          <span class="erase-icon${this.brushType_ === 'erase' ? ' selected' : ''}" title="Borrar"></span>
        </div>
        <div class="icon-slider">
          <div class="slider-title">Grosor</div>
          <input type="range" min="1" max="10" value="7" class="slider" />
          <div class="slider-minmax"><span>1</span><span>10</span></div>
        </div>
      `
      : '';
    return `
      <div class="matrix-sidebar${maximized ? ' maximized-sidebar' : ''}">
        <div class="sidebar-panel${this.openDrawer_ ? ' open' : ''}">
          <span class="drawer-arrow prev" title="Anterior"></span>
          <div class="drawer-viewport">${this.renderDrawer()}</div>
          <span class="drawer-arrow next" title="Siguiente"></span>
        </div>
        <div class="sidebar-bottom">
          <div class="sidebar-buttons">
            ${this.renderPicker('emotions', 'Emociones')}
            ${this.renderPicker('icons', 'Iconos')}
            ${ruler}
            <span class="button erase" title="Borrar todo"><span class="icon-delete"></span></span>
          </div>
          ${brushSlider}
        </div>
      </div>
    `;
  }

  // ------------------------------ vista compacta (carrusel) ----------------

  renderFrameModal(i) {
    const frames = this.frames();
    const canDelete = frames.length > 1;
    const delTag = canDelete ? ` <div class="oled-modal-frame-delete" data-frame="${i}"></div>` : '';
    return `
      <div class="oled-modal oled-modal-16 oled-modal-mini${i === this.currentFrame_ ? ' selected' : ''}" data-frame="${i}">
        <div class="oled-modal-frame-maximize" data-frame="${i}"></div>
        <div class="oled-modal-frame-leds">${downsampleRows(frames[i].leds, 4)}</div>
        <div class="oled-modal-frame-title">Frame ${i}${delTag}</div>
      </div>
      <div class="oled-frames-duration">
        Tiempo [ms]
        <input type="text" class="input-duration" data-frame="${i}" value="${frames[i].duration}" pattern="([0-9])" maxlength="4" />
      </div>
    `;
  }

  renderCarousel() {
    const frames = this.frames();
    let html = '';
    for (let i = 0; i < frames.length; i += 1) html += this.renderFrameModal(i);
    html += '<div class="oled-modal oled-frame-add"></div>';
    return html;
  }

  renderCompactContent_() {
    return `
      <div class="matrix-close" title="Cerrar"><span class="icon-cross11"></span></div>
      <div class="oled-modal-under">
        <div class="oled-frames">
          <div class="oled-frames-prev"></div>
          <div class="oled-carousel">
            <div class="oled-carousel-modals">${this.renderCarousel()}</div>
          </div>
          <div class="oled-frames-next"></div>
        </div>
        ${this.renderSidebar(false)}
      </div>
    `;
  }

  // ------------------------------ vista ampliada ---------------------------

  // data-content tiene 3 estados que el CSS distingue: ausente (marca sin número), "" (nada) o el
  // índice (marca + número). Por eso se omite el atributo en vez de dejarlo vacío.
  dataContentAttr(isLabelPosition, value) {
    if (this.rulerOn_ && isLabelPosition) return ` data-content="${value}"`;
    if (this.rulerBlanked_) return ' data-content=""';
    return '';
  }

  renderMaximizedRows() {
    const leds = this.currentLeds();
    let html = '';
    for (let row = 0; row < ROWS; row += 1) {
      const rowAttr = this.dataContentAttr(row % 8 === 0, row);
      let cells = '';
      for (let col = 0; col < COLS; col += 1) {
        const idx = (row * COLS) + col;
        const colAttr = row === 0 ? this.dataContentAttr(col % 8 === 0, col) : '';
        cells += `<div class="led ${leds[idx] ? 'led-on' : ''}" data-index="${idx}" data-row="${row}" data-col="${col}"${colAttr}></div>`;
      }
      html += `<div class="led-row"${rowAttr}>${cells}</div>`;
    }
    return html;
  }

  renderMaximizedContent_() {
    return `
      <div class="matrix-close" title="Volver"><span class="icon-cross11"></span></div>
      <div class="oled-modal-under maximized-card">
        <div class="oled-frames">
          <div class="oled-modal oled-modal-16 oled-modal-max">${this.renderMaximizedRows()}</div>
        </div>
        ${this.renderSidebar(true)}
      </div>
    `;
  }

  // ------------------------------ comun --------------------------------

  renderModalContent_() {
    return this.maximized_ ? this.renderMaximizedContent_() : this.renderCompactContent_();
  }

  modal() {
    return document.querySelector(`.${this.name_}Modal`);
  }

  rerenderModal() {
    const modal = this.modal();
    if (!modal) return;
    this.disposeDrawerEvents();
    modal.classList.toggle('maximized', this.maximized_);
    modal.innerHTML = this.renderModalContent_();
    this.addCustomModalEvents();
  }

  toggleMaximized(val) {
    this.maximized_ = val;
    this.openDrawer_ = null;
    this.rerenderModal();
  }

  // El paso entre frames se mide del DOM: la miniatura no mide el min-width del CSS y un paso fijo
  // deja el carrusel corrido.
  showItem() {
    const modal = this.modal();
    if (!modal) return;
    const carousel = modal.querySelector('.oled-carousel-modals');
    if (!carousel) return;
    const items = carousel.querySelectorAll('.oled-modal');
    const itemCount = items.length;
    const index = this.currentFrame_;
    const target = carousel.querySelector(`.oled-modal[data-frame="${index}"]`);
    const offset = (target && items[0]) ? target.offsetLeft - items[0].offsetLeft : 0;
    carousel.style.transform = `translateX(${-offset}px)`;
    const prev = modal.querySelector('.oled-frames-prev');
    const next = modal.querySelector('.oled-frames-next');
    if (prev) prev.classList.toggle('disabled', index <= 0);
    if (next) next.classList.toggle('disabled', index >= itemCount - 2);
  }

  markSelected() {
    const modal = this.modal();
    if (!modal) return;
    modal.querySelectorAll('.oled-carousel-modals .oled-modal').forEach((el) => {
      const f = el.getAttribute('data-frame');
      el.classList.toggle('selected', f !== null && Number(f) === this.currentFrame_);
    });
  }

  repaintFrameThumb(i) {
    const modal = this.modal();
    if (!modal) return;
    const el = modal.querySelector(`.oled-carousel-modals .oled-modal[data-frame="${i}"] .oled-modal-frame-leds`);
    if (el) el.innerHTML = downsampleRows(this.frames()[i].leds, 4);
  }

  repaintMaximizedGrid() {
    const modal = this.modal();
    if (!modal) return;
    const leds = this.currentLeds();
    modal.querySelectorAll('.oled-modal-max .led[data-index]').forEach((cell) => {
      cell.classList.toggle('led-on', !!leds[Number(cell.dataset.index)]);
    });
  }

  repaintCurrent() {
    if (this.maximized_) this.repaintMaximizedGrid();
    else this.repaintFrameThumb(this.currentFrame_);
  }

  // Muta el valor en el lugar y repinta a mano para no disparar un change por cada mouseover; el
  // change se dispara en mouseup.
  paintAround(row, col, on) {
    const leds = this.currentLeds();
    const modal = this.modal();
    const start = Math.floor(this.brushWidth_ / 2);
    const end = Math.ceil(this.brushWidth_ / 2);
    for (let i = -start; i < end; i += 1) {
      for (let j = -start; j < end; j += 1) {
        if (this.brushWidth_ <= 2 || ((i * i) + (j * j) <= start * end)) {
          const r = row + i;
          const c = col + j;
          if (r >= 0 && r < ROWS && c >= 0 && c < COLS) {
            const idx = (r * COLS) + c;
            leds[idx] = on;
            if (modal) {
              const cell = modal.querySelector(`.oled-modal-max .led[data-index="${idx}"]`);
              if (cell) cell.classList.toggle('led-on', on);
            }
          }
        }
      }
    }
    this.paintBlockContent();
  }

  deleteFrame(i) {
    const frames = this.frames();
    if (frames.length <= 1) return;
    const next = frames.filter((_, idx) => idx !== i);
    this.currentFrame_ = (this.currentFrame_ - 1 > 0) ? this.currentFrame_ - 1 : 0;
    this.setFrames(next);
    this.rerenderModal();
    this.showItem();
    this.markSelected();
  }

  // ------------------------------ eventos --------------------------------

  disposeDrawerEvents() {
    this.drawerEvents_.forEach((event) => Blockly.browserEvents.unbind(event));
    this.drawerEvents_ = [];
  }

  addDrawerEvent(node, name, func) {
    this.drawerEvents_.push(Blockly.browserEvents.conditionalBind(node, name, this, func));
  }

  paintDrawer() {
    const modal = this.modal();
    if (!modal) return;
    this.disposeDrawerEvents();
    const viewport = modal.querySelector('.drawer-viewport');
    viewport.innerHTML = this.renderDrawer();
    // El viewport no se recrea y conservaría el scroll de la categoría anterior.
    viewport.scrollLeft = 0;
    modal.querySelector('.sidebar-panel').classList.toggle('open', !!this.openDrawer_);
    modal.querySelectorAll('.sidebar-buttons .picker').forEach((picker) => {
      picker.classList.toggle('selected', picker.dataset.drawer === this.openDrawer_);
    });
    modal.querySelectorAll('.drawer-viewport .preset').forEach((preset) => {
      this.addDrawerEvent(preset, 'click', () => {
        this.setCurrentLeds(presetToLeds(PRESETS[this.openDrawer_][preset.dataset.preset]));
        this.repaintCurrent();
      });
    });
  }

  addSidebarEvents(modal) {
    modal.querySelectorAll('.sidebar-buttons .picker').forEach((picker) => {
      this.addEvent_(picker, 'click', this, () => {
        const { drawer } = picker.dataset;
        this.openDrawer_ = (this.openDrawer_ === drawer) ? null : drawer;
        this.paintDrawer();
      });
    });

    const viewport = modal.querySelector('.drawer-viewport');
    const step = 3 * (PRESET_WIDTH + PRESET_GAP);
    this.addEvent_(modal.querySelector('.drawer-arrow.prev'), 'click', this, () => {
      viewport.scrollBy({ left: -step, behavior: 'smooth' });
    });
    this.addEvent_(modal.querySelector('.drawer-arrow.next'), 'click', this, () => {
      viewport.scrollBy({ left: step, behavior: 'smooth' });
    });

    const erase = modal.querySelector('.sidebar-buttons .erase');
    if (erase) {
      this.addEvent_(erase, 'click', this, () => {
        this.setCurrentLeds(emptyLeds());
        this.repaintCurrent();
      });
    }
    const ruler = modal.querySelector('.sidebar-buttons .ruler');
    if (ruler) {
      this.addEvent_(ruler, 'click', this, () => {
        if (this.rulerOn_) this.rulerBlanked_ = true;
        this.rulerOn_ = !this.rulerOn_;
        this.rerenderModal();
      });
    }

    this.paintDrawer();
  }

  addCarouselEvents(modal) {
    const prev = modal.querySelector('.oled-frames-prev');
    const next = modal.querySelector('.oled-frames-next');
    this.addEvent_(prev, 'click', this, () => {
      if (this.currentFrame_ <= 0) return;
      this.currentFrame_ -= 1;
      this.showItem();
      this.markSelected();
    });
    this.addEvent_(next, 'click', this, () => {
      if (this.currentFrame_ >= this.frames().length - 1) return;
      this.currentFrame_ += 1;
      this.showItem();
      this.markSelected();
    });

    modal.querySelectorAll('.oled-carousel-modals .oled-modal').forEach((el) => {
      if (el.classList.contains('oled-frame-add')) {
        this.addEvent_(el, 'click', this, () => {
          const frames = [...this.frames(), { leds: emptyLeds(), duration: 1000 }];
          this.currentFrame_ = frames.length - 1;
          this.setFrames(frames);
          this.rerenderModal();
          this.showItem();
          this.markSelected();
        });
        return;
      }
      const i = Number(el.getAttribute('data-frame'));
      const maximize = el.querySelector('.oled-modal-frame-maximize');
      if (maximize) {
        this.addEvent_(maximize, 'click', this, (event) => {
          event.stopPropagation();
          this.currentFrame_ = i;
          this.toggleMaximized(true);
        });
      }
      const del = el.querySelector('.oled-modal-frame-delete');
      if (del) {
        this.addEvent_(del, 'click', this, (event) => {
          event.stopPropagation();
          this.deleteFrame(i);
        });
      }
      this.addEvent_(el, 'click', this, () => {
        if (i === this.currentFrame_) {
          this.toggleMaximized(true);
        } else {
          this.currentFrame_ = i;
          this.showItem();
          this.markSelected();
        }
      });
    });

    modal.querySelectorAll('.input-duration').forEach((input) => {
      const i = Number(input.getAttribute('data-frame'));
      this.addEvent_(input, 'input', this, () => {
        input.value = input.value.replace(/[^0-9]/g, '');
      });
      this.addEvent_(input, 'blur', this, () => {
        this.setFrameDuration(i, input.value ? parseInt(input.value, 10) : 1000);
      });
    });
  }

  addMaximizedEvents(modal) {
    modal.querySelectorAll('.oled-modal-max .led[data-index]').forEach((cell) => {
      const row = Number(cell.dataset.row);
      const col = Number(cell.dataset.col);
      this.addEvent_(cell, 'mousedown', this, (event) => {
        event.preventDefault();
        this.painting_ = this.brushType_ === BrushTypes.BRUSH;
        this.paintAround(row, col, this.painting_);
      });
      this.addEvent_(cell, 'mouseover', this, (event) => {
        if (event.buttons !== 1) return;
        this.paintAround(row, col, this.painting_);
      });
    });
    // Un único change al soltar (evita regenerar el sketch píxel a píxel).
    this.addEvent_(modal, 'mouseup', this, () => this.updateWorkspace());

    const brushIcon = modal.querySelector('.icon-brush .brush-icon');
    const eraseIcon = modal.querySelector('.icon-brush .erase-icon');
    this.addEvent_(brushIcon, 'click', this, () => {
      this.brushType_ = BrushTypes.BRUSH;
      brushIcon.classList.add('selected');
      eraseIcon.classList.remove('selected');
    });
    this.addEvent_(eraseIcon, 'click', this, () => {
      this.brushType_ = BrushTypes.ERASE;
      eraseIcon.classList.add('selected');
      brushIcon.classList.remove('selected');
    });

    const slider = modal.querySelector('.icon-slider .slider');
    if (slider) {
      this.brushWidth_ = mapBrushValue(Number(slider.value));
      this.addEvent_(slider, 'input', this, (event) => {
        this.brushWidth_ = mapBrushValue(Number(event.target.value));
      });
    }
  }

  addCustomModalEvents() {
    const modal = this.modal();
    if (!modal) return;

    this.addSidebarEvents(modal);

    this.addEvent_(modal.querySelector('.matrix-close'), 'click', this, () => {
      if (this.maximized_) {
        this.toggleMaximized(false);
      } else {
        this.updateWorkspace();
        this.closeModal();
      }
    });

    if (this.maximized_) {
      this.addMaximizedEvents(modal);
    } else {
      this.addCarouselEvents(modal);
      this.showItem();
      this.markSelected();
    }
  }

  disposeEvents() {
    this.disposeDrawerEvents();
    super.disposeEvents();
  }
}
